module.exports = __webpack_public_path__ + "images/emoji/euro.e3d6d0651e6020c6c42e.png";